<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('customerName')">
          <el-input
            v-model="queryForm.name"
            size="small"
            :placeholder="$t('customerName')"
          />
        </el-form-item>
        <el-form-item :label="$t('linkPhone')">
          <el-input
            v-model="queryForm.phoneNo"
            size="small"
            :placeholder="$t('linkPhone')"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
          >
            <i class="el-icon-search" /> {{ $t("query") }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column :label="$t('customerName')" width="180">
          <template slot-scope="scope">
            {{ scope.row.name }} {{ scope.row.surname }}
          </template>
        </el-table-column>
        <el-table-column prop="phoneNo" width="160" :label="$t('linkPhone')" />
        <el-table-column
          prop="customerCode"
          width="160"
          :label="$t('customerCode')"
        />
        <el-table-column width="180" :label="$t('currentDepositLimit')">
          <template slot-scope="scope">
            FCFA {{ (scope.row.currentDepositLimit || 0).formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column width="180" :label="$t('monthlyDepositLimit')">
          <template slot-scope="scope">
            <span v-if="scope.row.monthlyDepositLimit">
              FCFA {{ scope.row.monthlyDepositLimit.formatMoney(0) }}
            </span>
            <span v-else class="text-danger">{{ $t("notSet") }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('extend')" width="120">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="openEdit(scope.row)">
              {{ $t("edit") }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="
        editRow
          ? editRow.name + ' ' + editRow.surname
          : $t('currentDepositLimit')
      "
      :visible.sync="drawer"
      direction="rtl"
      :size="400"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
    >
      <el-form
        :model="limitForm"
        :rules="rules"
        ref="limitForm"
        label-position="top"
        style="padding: 0 20px"
      >
        <el-form-item :label="$t('linkPhone')">
          <el-input
            :value="editRow ? editRow.phoneNo : ''"
            disabled
            size="medium"
          />
        </el-form-item>

        <el-form-item
          :label="$t('currentDepositLimit')"
          prop="currentDepositLimit"
        >
          <el-input
            size="medium"
            v-model="limitForm.currentDepositLimit"
            type="tel"
            :placeholder="$t('currentDepositLimit')"
            @input="
              limitForm.currentDepositLimit = limitForm.currentDepositLimit
                .replace(/[^0-9]/g, '')
                .formatMoney(0, ' ')
            "
          >
            <template slot="prepend">FCFA</template>
          </el-input>
        </el-form-item>

        <el-form-item
          :label="$t('monthlyDepositLimit')"
          prop="monthlyDepositLimit"
        >
          <el-input
            size="medium"
            v-model="limitForm.monthlyDepositLimit"
            type="tel"
            :placeholder="$t('monthlyDepositLimit')"
            @input="
              limitForm.monthlyDepositLimit = limitForm.monthlyDepositLimit
                .replace(/[^0-9]/g, '')
                .formatMoney(0, ' ')
            "
          >
            <template slot="prepend">FCFA</template>
          </el-input>
        </el-form-item>

        <div class="bottom-button">
          <el-button
            size="medium"
            type="primary"
            :loading="isSubmitting"
            @click="submitLimit('limitForm')"
          >
            {{ $t("submit") }}
          </el-button>
        </div>
      </el-form>
    </el-drawer>
  </el-card>
</template>

<script>
import customer from "@/api/customer";

export default {
  name: "customerDepositLimitManaged",
  data() {
    return {
      queryForm: {},
      queryTableHeight: String,
      isLoading: false,
      tableData: {},
      pageSize: 20,
      currentPage: 1,

      drawer: false,
      editRow: null,
      limitForm: { currentDepositLimit: "", monthlyDepositLimit: "" },
      isSubmitting: false,
    };
  },
  computed: {
    rules() {
      return {
        currentDepositLimit: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (
                !String(value).replace(/\s/g, "") ||
                parseInt(String(value).replace(/\s/g, "")) <= 0
              )
                callback(new Error(this.$t("requiredFields")));
              else callback();
            },
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList() {
      this.isLoading = true;
      customer.getPage({
        param: {
          current: this.currentPage,
          size: this.pageSize,
          ...this.queryForm,
        },
        success: (res) => {
          this.tableData = res.data || {};
          this.isLoading = false;
        },
      });
    },
    openEdit(row) {
      this.editRow = row;
      this.limitForm = {
        currentDepositLimit: row.currentDepositLimit
          ? String(row.currentDepositLimit)
          : "",
        monthlyDepositLimit: row.monthlyDepositLimit
          ? String(row.monthlyDepositLimit)
          : "",
      };
      this.drawer = true;
    },
    submitLimit(refName) {
      this.$refs[refName].validate((valid) => {
        if (!valid) return false;
        this.isSubmitting = true;
        customer.updateDepositLimit({
          param: {
            customerId: this.editRow.id,
            currentDepositLimit: parseInt(
              String(this.limitForm.currentDepositLimit).replace(/\s/g, ""),
            ),
            monthlyDepositLimit: this.limitForm.monthlyDepositLimit
              ? parseInt(
                  String(this.limitForm.monthlyDepositLimit).replace(/\s/g, ""),
                )
              : null,
          },
          success: (res) => {
            this.isSubmitting = false;
            if (res.code == 200) {
              this.$message.success(this.$t("operateSuccessfully"));
              this.drawer = false;
              this.getList();
            } else {
              this.$message.warning(this.$t(res.msg));
            }
          },
        });
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.queryTableHeight = this.$refs.pageHead.offsetHeight + 15 + "px";
      this.getList();
    });
  },
};
</script>
